<template>
  <section class="summary-panel display-panel">
    <div class="summary-title">
      <i class="far fa-money-bill-alt"></i>
      <span>{{ $t('customerDisplay.payment') }}</span>
    </div>
    <div class="payment-metrics">
      <div class="payment-card subtotal-card">
        <div class="payment-card-label">
          <i class="far fa-money-bill-alt"></i>
          <span>{{ $t('customerDisplay.subtotal') }}</span>
        </div>
        <strong>{{ formatAmount(total) }}</strong>
      </div>
      <div class="payment-card paid-card">
        <div class="payment-card-label">
          <i class="far fa-check-circle"></i>
          <span>{{ $t('customerDisplay.paid') }}</span>
        </div>
        <strong>{{ formatAmount(paid) }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PaymentSummaryPanel',
  props: {
    paid: { type: Number, default: 0 },
    total: { type: Number, default: 0 }
  },
  methods: {
    formatAmount(value) {
      return `$${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    }
  }
}
</script>
